import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobeIcon, CheckCircleIcon, RocketIcon } from 'lucide-react';
import Button from '../components/ui/Button';
interface OnboardingProps {
  onComplete: () => void;
}
const Onboarding: React.FC<OnboardingProps> = ({
  onComplete
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  const slides = [{
    title: 'Global Reach',
    description: 'Find job opportunities anywhere in the world, even on Mars.',
    icon: <GlobeIcon size={80} className="text-teal-500 mb-6" data-id="element-385" />
  }, {
    title: 'Reliable Listings',
    description: 'Only verified and up-to-date job postings from trusted companies.',
    icon: <CheckCircleIcon size={80} className="text-teal-500 mb-6" data-id="element-386" />
  }, {
    title: 'Easy Application',
    description: 'Apply with just a few taps and track your application status in real-time.',
    icon: <RocketIcon size={80} className="text-teal-500 mb-6" data-id="element-387" />
  }];
  const nextSlide = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      onComplete();
      navigate('/login');
    }
  };
  const skipOnboarding = () => {
    onComplete();
    navigate('/login');
  };
  return <div className="min-h-screen bg-gradient-to-b from-gray-900 to-gray-800 flex flex-col justify-between p-6" data-id="element-388">
      <div className="absolute top-6 right-6" data-id="element-389">
        <button onClick={skipOnboarding} className="text-gray-400 hover:text-white transition-colors" data-id="element-390">
          Skip
        </button>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center text-center" data-id="element-391">
        {slides[currentSlide].icon}
        <h1 className="text-3xl font-bold text-white mb-4" data-id="element-392">
          {slides[currentSlide].title}
        </h1>
        <p className="text-gray-300 mb-8 max-w-xs" data-id="element-393">
          {slides[currentSlide].description}
        </p>
        <div className="flex space-x-2 mb-8" data-id="element-394">
          {slides.map((_, index) => <div key={index} className={`h-2 rounded-full transition-all duration-300 ${index === currentSlide ? 'w-8 bg-teal-500' : 'w-2 bg-gray-600'}`} data-id="element-395" />)}
        </div>
      </div>
      <div className="w-full" data-id="element-396">
        <Button variant="primary" fullWidth size="lg" onClick={nextSlide} data-id="element-397">
          {currentSlide < slides.length - 1 ? 'Continue' : 'Get Started'}
        </Button>
      </div>
    </div>;
};
export default Onboarding;